import { combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit'
import { UnknownAction } from 'redux'
import asyncResultReducer from './asyncResultSlice'
import calcReducer from './calcSlice'
import diagnosisReviewReducer from './diagnosisReviewSlice'
import drugReducer from './drugSlice'
import formReducer from './formSlice'
import formModelReducer from './formModelSlice'
import labsReducer from './labsSlice'
import neurologicWeaknessReviewReducer from './neurologicWeaknessReviewSlice'
import renderReducer from './formRenderSlice'
import { asyncResultMw } from './asyncResultMw'
import { diagnosisReviewInputMw } from './diagnosisReviewInputMw'
import dupeDetectMw from './dupeDetectMw'
import { FormModelPersistMiddleware } from './formmodelPersistMw'
import { CalcMiddleware } from './formAssertion3Mw'

const formRootReducer = combineReducers({
	asyncResult: asyncResultReducer,
	calc: calcReducer,
	diagnosisReview: diagnosisReviewReducer,
	drug: drugReducer,
	form: formReducer,
	formModel: formModelReducer,
	labs: labsReducer,
	neurologicWeaknessReview: neurologicWeaknessReviewReducer,
	render: renderReducer,
})

export const createIsolatedFormStore = () => {
	const calcMw = new CalcMiddleware()
	const persistMw = new FormModelPersistMiddleware()
	const store = configureStore({
		reducer: formRootReducer,
		middleware: (getDefault) => getDefault({
			thunk: { extraArgument: { calcMw, persistMw } }
		}).concat(
			asyncResultMw,
			diagnosisReviewInputMw,
			dupeDetectMw,
			calcMw.middleware,
			persistMw.middleware,
		),
	})
	return store
}

interface FormMwExtraArgument {
	calcMw: CalcMiddleware
	persistMw: FormModelPersistMiddleware
}

export type FormStore = ReturnType<typeof createIsolatedFormStore>
export type FormRootState = ReturnType<typeof formRootReducer>
export type FormDispatch = FormStore['dispatch']
// https://redux.js.org/usage/usage-with-typescript#type-checking-redux-thunks
export type FormThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	FormRootState,
	FormMwExtraArgument,
	UnknownAction
>
